import { setTerms } from './helpers';

export const setRepair = setTerms('repair');
